import React from 'react';
import PropTypes from 'prop-types';
import {List, Map} from 'immutable';
import FlatBarChart from 'generic/FlatBarChart/FlatBarChart.react';
import {stats} from 'lib/StatsUtil';

const correctColorClass = 'completion-graph-correct';
const incorrectColorClass = 'completion-graph-incorrect';
const unansweredColorClass = 'completion-graph-unanswered';

import './assignment-completion-accuracy.scss';

export default class AssignmentCompletionAccuracy extends React.Component {
  static propTypes = {
    numberCorrect: PropTypes.number.isRequired,
    numberIncorrect: PropTypes.number.isRequired,
    numberUnanswered: PropTypes.number.isRequired
  }

  constructor(props) {
    super(props);
    const total = props.numberCorrect
      + props.numberIncorrect
      + props.numberUnanswered;

    const getPercentage = (numerator) => {
      return stats.percentage(numerator, total, true);
    };

    this.correct = new Map({
      fillColorClass: correctColorClass,
      fillPercentage: getPercentage(props.numberCorrect)
    });

    this.incorrect = new Map({
      fillColorClass: incorrectColorClass,
      fillPercentage: getPercentage(props.numberIncorrect)
    });

    this.unanswered = new Map({
      fillColorClass: unansweredColorClass,
      fillPercentage: getPercentage(props.numberUnanswered)
    });
  }

  render() {
    /*
      Explicitly setting the tooltip text here to NULL, there is a tooltip that wraps
      this at the usage site.
    */
    return (
      <FlatBarChart
        tooltipText={null}
        inline={true}
        data={new List([this.correct, this.incorrect, this.unanswered])}
      />
    );
  }
}
